const NewBatchFileValidationWorker = () => {
    self.stopProcessing = false;
    self.config = null;

    self.processValidation = (request) => {
        if (!self.config) {
            console.log('NO CONFIG');
            postMessage({
                type: 'CONFIG_FETCH_FAILED',
                data: 'Configuration not initialized'
            });
            return;
        }

        const { fileContents } = request;
        const lines = fileContents.split(/\r?\n/).filter(line => line.trim() !== ''); // Split by new lines and filter out empty lines
        processLine(0, lines, { status: 'InProgress', messages: [], progress: 0 }, []);
    };

    const processLine = (currentIndex, lines, job, sequenceCollector) => {
        if (self.stopProcessing) {
            return;
        }
        const lineGroup = lines.slice(currentIndex, currentIndex + 1000);
        for (let i = 0; i < lineGroup.length; i++) {
            const columns = lineGroup[i].split('\t');
            validateLine(currentIndex + i + 1, columns, job, sequenceCollector);
        }

        if (lines.length > currentIndex + lineGroup.length) {
            if ((currentIndex + lineGroup.length) % 100 === 0) {
                job.progress = ((currentIndex + lineGroup.length) / lines.length) * 100;
                postMessage({
                    type: 'VALIDATION_PROGRESS',
                    data: {
                        ...job
                    }
                });
            }
            setTimeout(() => processLine(currentIndex + lineGroup.length, lines, job, sequenceCollector), 0);
        } else {
            job.status = job.messages.length > 0 ? 'Failed' : 'Success';
            postMessage({
                type: 'VALIDATION_COMPLETE',
                data: {
                    ...job
                }
            });
        }
    };

    const validateLine = (lineNumber, columns, job, sequenceCollector) => {
        if (!self.config) {
            job.messages.push(`Line ${lineNumber}: Configuration not properly initialized.`);
            return;
        }

        self.config.forEach((columnConfig, index) => {
            const columnValue = columns[index];
            const columnName = columnConfig.name;

            if (columnConfig.dataType === 'string' && columnConfig.fieldLength && columnValue && columnValue.length > columnConfig.fieldLength) {
                job.messages.push(`Line ${lineNumber}: ${columnName} (Column ${index + 1}) length must be less than or equal to ${columnConfig.fieldLength}.`);
            }

            if (columnConfig.dataType === 'date' && columnValue && !self.isValidDate(columnValue)) {
                job.messages.push(`Line ${lineNumber}: ${columnName} (Column ${index + 1}) must be in the format (mm/dd/yyyy).`);
            }

            if (columnConfig.dataType === 'bigint' && columnValue && isNaN(columnValue)) {
                job.messages.push(`Line ${lineNumber}: ${columnName} (Column ${index + 1}) must be an integer.`);
            }

            if (columnConfig.dataType === 'decimal' && columnValue) {
                const decimalValue = parseFloat(columnValue);
                if (isNaN(decimalValue)) {
                    job.messages.push(`Line ${lineNumber}: ${columnName} (Column ${index + 1}) must be a number. Exclude commas and dollar signs. Can include decimals.`);
                } else {
                    const fieldLength = columnConfig.fieldLength.trim().split(',');
                    if (fieldLength.length === 2) {
                        const [precision, scale] = fieldLength.map(Number);
                        const [integerPart, fractionalPart = ''] = columnValue.split('.');
                        // Validate the total number of digits (precision) and the maximum number of digits after the decimal point (scale)
                        if ((integerPart.length + fractionalPart.length > precision) || fractionalPart.length > scale) {
                            job.messages.push(`Line ${lineNumber}: ${columnName} (Column ${index + 1}) must be a number with precision ${precision} and scale ${scale}. Current value: ${columnValue}.`);
                        }
                    }
                }
            }
        });

        // Additional sequence number validation
        const sequenceNumber = columns[0];

        if (sequenceCollector.length !== 0 && !isNaN(sequenceNumber)) {
            const lastSequence = sequenceCollector[sequenceCollector.length - 1];
            if (!isNaN(lastSequence) && Number(sequenceNumber) <= Number(lastSequence)) {
                job.messages.push(`Line ${lineNumber}: Sequence Number (Column 1) must be in order from smallest to largest.`);
            }
        }

        if (sequenceCollector.includes(sequenceNumber)) {
            job.messages.push(`Line ${lineNumber}: Sequence Number (Column 1) must be unique.`);
        } else {
            sequenceCollector.push(sequenceNumber);
        }
    };

    self.isValidDate = (dateString) => {
        const regex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|1[0-9]|2[0-9]|3[01])\/(18|19|20|21|22)\d\d$/;
        return regex.test(dateString);
    };

    self.onmessage = (args) => {
        const { type, request, config: newConfig } = args.data;

        if (type === 'CANCELLATION') {
            self.stopProcessing = true;
        } else if (type === 'VALIDATION') {
            self.stopProcessing = false;
            setTimeout(() => self.processValidation(request), 0);
        } else if (type === 'INIT_CONFIG') {
            self.config = newConfig;
            postMessage({
                type: 'CONFIG_INITIALIZED',
                data: 'Configuration initialized successfully'
            });
        }
    };
};

let code = NewBatchFileValidationWorker.toString();
code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));

const blob = new Blob([code], { type: "application/javascript" });
const workerScriptUrl = URL.createObjectURL(blob);

export default workerScriptUrl;
